import { useEffect } from 'react'

import { useMaestroSession } from '@maestro/commerce-blocks/providers/maestro-session/maestro-session.context'
import { theme } from '@maestro/local/theme'
import { useHash } from '@pearlconvert/ui/hooks/use-hash'

export function useLoyaltyRegisterModal() {
  const { session } = useMaestroSession()
  const { getHashParamValue, removeHashParam } = useHash()
  const { modalKey: loyaltyRegisterModalKey } = theme().registerPage

  useEffect(() => {
    const hasRegisterHash =
      getHashParamValue(loyaltyRegisterModalKey) !== undefined
    const isUserLoggedIn = !!session?.user?.id

    if (hasRegisterHash && isUserLoggedIn) {
      removeHashParam(loyaltyRegisterModalKey)
    }
  }, [
    getHashParamValue,
    loyaltyRegisterModalKey,
    removeHashParam,
    session?.user?.id,
  ])

  return { loyaltyRegisterModalKey }
}
